<template>
  <el-tabs tab-position="left" v-model="active">
    <el-tab-pane label="CDN刷新" name='refresh'>
      <refresh-cdn v-if="active==='refresh'" :quotas="fileRefreshQuotas"></refresh-cdn>
    </el-tab-pane>
    <el-tab-pane label="CDN预热" name='preheat'>
      <preheat-cdn v-if="active==='preheat'" :quotas="filePreheatQuotas"></preheat-cdn>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import refreshCdn from './refreshCdn.vue';
import preheatCdn from './preheatCdn.vue';
import { xpsApi } from '@/api';
export default {
  components: {
    refreshCdn,
    preheatCdn
  },
  data () {
    return {
      active: "refresh",
      filePreheatQuotas: {},
      fileRefreshQuotas: {}
    }
  },
  mounted () {
    this.getCDNQuota();
  },
  methods: {
    // 改变tab选项
    changeTab (active) {
      this.active = active;
    },
    // 获取华为云Cdn配额
    async getCDNQuota () {
      const res = await xpsApi.getCDNQuota();
      let result = res && res.data;
      if (result && result.quotas) {
        if (Array.isArray(result.quotas)) {
          this.filePreheatQuotas = result.quotas.find(item => item.type === 'preheat') || {};
          this.fileRefreshQuotas = result.quotas.find(item => item.type === 'file_refresh') || {};
        }
      }
    }
  }
}
</script>

